import React from 'react';
import ActivityCard from '../ActivityCard';


interface ActivityOverviewDashboardListProps {
  data?: any[];
}

const ActivityOverviewDashboardList: React.FC<ActivityOverviewDashboardListProps> = ({ data }) => {

  return (
    <>
      {data?.map((activity, index) => (
        <ActivityCard
          key={index}
          name={activity?.name}
          type={activity?.type}
          participation_level={activity?.participation_level}
          description={activity?.description}
          tax_category={activity?.tax_category}
          total_time_spent={activity?.total_time_spent}
        />
      ))}
    </>
  );
};

export default ActivityOverviewDashboardList;